/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'in': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="rotate(-180 12 11.5)" _stroke="#00272E"><path pid="0" d="M.3 6.708h10.2"/><polyline pid="1" points="8.1 4.37441667 10.5 6.70775 8.1 9.04108333"/><path pid="2" d="M14.1 13.708V.29"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/in.js